import { render, staticRenderFns } from "./MatterDefendantForm.vue?vue&type=template&id=10cf2c46&"
import script from "./MatterDefendantForm.vue?vue&type=script&lang=js&"
export * from "./MatterDefendantForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterDefendantForm.vue?vue&type=style&index=0&id=10cf2c46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports